const dynamicPackage = {
  detailedPlan: "Plano Detalhado", // translated
  minimum: "Mínimo", // translated
  maximum: "Máximo", // translated
};

export default dynamicPackage;
